import { render, staticRenderFns } from "./bindPhone.vue?vue&type=template&id=ab20b68e"
import script from "./bindPhone.vue?vue&type=script&lang=js"
export * from "./bindPhone.vue?vue&type=script&lang=js"
import style0 from "./bindPhone.vue?vue&type=style&index=0&id=ab20b68e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports